import { Component, Input, OnInit } from '@angular/core';
import { AppStateService } from '../../services/appState.service';

import { ModalService } from 'app/allgemeinesTS_CSS/_modal';

import * as allgemeineFunktionen from '../../allgemeinesTS_CSS/checkUA';

@Component({
  selector: 'app-menue',
  templateUrl: './menue.component.html',
  styleUrls: ['../../allgemeinesTS_CSS/tooltip.css',
    './menue.component.css',
    '../../allgemeinesTS_CSS/cssButton.css'
  ]
})
export class MenueComponent implements OnInit {
  public appStatus: Object = {};
  protected pfadFlaggen = 'deps/images/Flaggen/';
  protected sprache: string;
  public seiteWirdNeuGeladen = false;
  constructor(private appStateService: AppStateService, private modalService: ModalService) {
    this.appStateService.appStatus$.subscribe(res => { this.appStatus = res; });
  }
  ngOnInit() {
  }
  getSprache() {
    return sessionStorage.getItem('Sprache');
  }
  getUser() {
    return localStorage.getItem('email');
  }
  getVersion() {
    return localStorage.getItem('Version');
  }
  setzeSprache(sprache: string) {
    this.seiteWirdNeuGeladen = true;
    sessionStorage.setItem('Sprache', sprache);
    location.reload();
  }
  CreateDesktopLink() {
    const clientInformation = allgemeineFunktionen.GetHostInformation(navigator.userAgent);
    switch (clientInformation.detectedOS.split(",")[0].trim()) {
      case "Windows":
        //create 'a' element
        let link = document.createElement("a");
        //replace "file" with link to file you want to download
        link.setAttribute("href", "assets/Downloads/OPLCLauncher.exe");
        // replace "file" with filename you want as name for storing
        link.setAttribute("download", "OPLCLauncher.exe");
        //virtually click <a> element to initiate download
        link.click();
        break;
      case "iOS":
      case "Apple iPadOS":
        location.href = "#/iOSLinkDocumentation";
        break;
      default:
        this.openModal('OSNotDetected');
        break;
    }
  }

  openModal(id: string) {
    this.modalService.open(id);
    return false;
  }
  closeModal(id: string) {
    this.modalService.close(id);
  }
}
